/**
 * API Configuration
 * Single source of truth for all API endpoints and configuration
 */

// Get the API base URL from environment variables or use defaults
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.leckerorder.com'

// API endpoints configuration
export const API_ENDPOINTS = {
  // General endpoints
  general: (restaurantId: number) => `${API_BASE_URL}/general?restaurantId=${restaurantId}`,
  
  // Opening hours endpoints
  openingTimes: (restaurantId: number) => `${API_BASE_URL}/openingTimes?restaurantId=${restaurantId}`,
  addOpeningTime: () => `${API_BASE_URL}/addOpeningTime`,
  removeOpeningTime: () => `${API_BASE_URL}/removeOpeningTime`,
  
  // Holidays endpoints
  holidaysTimes: (restaurantId: number) => `${API_BASE_URL}/holidaysTimes?restaurantId=${restaurantId}`,
  updateHolidaysTimes: () => `${API_BASE_URL}/updateHolidaysTimes`,
  
  // Closing times endpoints
  closingTimes: (restaurantId: number) => `${API_BASE_URL}/closingTimes?restaurantId=${restaurantId}`,
  addClosingTime: () => `${API_BASE_URL}/addClosingTime`,
  removeClosingTime: () => `${API_BASE_URL}/removeClosingTime`,

  // Status check endpoint
  checkIsOpened: (restaurantId: number) => `${API_BASE_URL}/checkIsOpened?restaurantId=${restaurantId}`,
} as const

// Export the base URL for any custom use cases
export const getApiBaseUrl = () => API_BASE_URL

